import { AvMicroserviceApi } from '@availity/api-axios';
import envVar, { getSpecificEnv } from '@availity/env-var';

const specificEnv = getSpecificEnv();
const essentialsHost = specificEnv === 'prod' ? 'essentials' : `${specificEnv}-essentials`;

// This API is used to get and update the user invitations list
const UserOrgMgmtCloudApi = new AvMicroserviceApi({
  url: `https://${essentialsHost}.availity.com/cloud/web/onb/user-org-management/v1/users/`,
  path: '',
  version: '',
  name: '',
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'X-Client-ID': envVar({
      prod: 'c1272e00-6612-4cbb-a16e-8d9029ea7024',
      local: 'a65f9098-229d-4029-8dcc-93106b6e2d43',
    }),
  },
});

export async function updateInviteListCloud(config) {
  const response = await UserOrgMgmtCloudApi.put({ id: 'invitations', ...config });
  return response.data;
}

export async function getInviteListCloud(config) {
  const response = await UserOrgMgmtCloudApi.query({ id: 'invitations', ...config });

  return response.data;
}
